import { render } from "./navigation-footer.vue?vue&type=template&id=572b233e"
import script from "./navigation-footer.vue?vue&type=script&lang=js"
export * from "./navigation-footer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__